import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-20 bg-background-50 relative overflow-hidden">
      {/* Decorative organic curves */}
      <div className="absolute top-0 left-0 w-64 h-64 opacity-[0.04]">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path d="M20 180 Q40 100 80 120 T140 60 T200 100" fill="none" stroke="currentColor" strokeWidth="2" className="text-foreground-950" />
          <path d="M0 160 Q60 140 100 100 T180 40" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-foreground-950" />
          <path d="M40 200 Q80 120 120 140 T200 80" fill="none" stroke="currentColor" strokeWidth="1" className="text-foreground-950" />
        </svg>
      </div>

      <div className="flex flex-col lg:flex-row items-stretch gap-0 max-w-6xl mx-auto relative z-10">
        {/* Image column */}
        <div className="lg:w-[30%] relative z-20">
          <div className="rounded-2xl overflow-hidden h-[400px] lg:h-full lg:min-h-[480px] lg:-mr-[15%] lg:mt-4">
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20young%20adult%20unboxing%20a%20fashion%20package%20with%20genuine%20delighted%20expression%20warm%20natural%20window%20lighting%20clean%20minimal%20aesthetic%20soft%20cream%20wall%20background%20lifestyle%20editorial%20photography%20casual%20elegant%20style%20authentic%20joyful%20moment&width=600&height=800&seq=testimonial-user-v2&orientation=portrait"
              alt="Zufriedener Oopbuy Nutzer"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Content column */}
        <div className="lg:w-[70%] bg-foreground-950 rounded-3xl p-8 md:p-12 lg:p-16 flex flex-col justify-center">
          <div className="text-6xl text-accent-300/60 font-heading mb-6 leading-none">"</div>
          <blockquote className="text-lg md:text-[22px] text-white leading-[1.6] mb-8">
            {t('testimonial.quote')}
          </blockquote>
          <div className="mb-8">
            <p className="text-white text-sm font-semibold">{t('testimonial.name')}</p>
            <p className="text-white/50 text-sm">{t('testimonial.role')}</p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center h-12 px-6 rounded-full bg-accent-400 text-foreground-950 text-sm font-semibold hover:bg-accent-500 transition-colors w-fit whitespace-nowrap cursor-pointer"
          >
            {t('testimonial.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}